export default __webpack_public_path__ + "static/media/05.06b0eb5d.jpg";